import { render, staticRenderFns } from "./SelectModelPop.vue?vue&type=template&id=baa53b34&scoped=true"
import script from "./SelectModelPop.vue?vue&type=script&lang=js"
export * from "./SelectModelPop.vue?vue&type=script&lang=js"
import style0 from "./SelectModelPop.vue?vue&type=style&index=0&id=baa53b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa53b34",
  null
  
)

export default component.exports